import Nullstack from 'nullstack';
export default function IconBrandNotion({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-notion",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 7h3l6 6"
  }), "   ", Nullstack.element("path", {
    d: "M8 7v10"
  }), "   ", Nullstack.element("path", {
    d: "M7 17h2"
  }), "   ", Nullstack.element("path", {
    d: "M15 7h2"
  }), "   ", Nullstack.element("path", {
    d: "M16 7v10h-1l-7 -7"
  }), " ");
}